<template>
  <div class="search-bar">
    <div class="card-block">
      <input
        type="text"
        class="form-control"
        placeholder="Search by dashboard content"
        :value="searchQuery"
        @input="queryChanged($event)"
      >
      <div class="mt-10 search-bar__filters">
        <label class="search-bar__filter">
          <span>Show</span>
          <select
            v-model="perPage"
            class="form-control"
            style="display: inline-block; width: auto;"
          >
            <option v-for="item in options" :key="item" :value="item">{{ item }}</option>
          </select>
          <span v-if="total">of {{ total }}</span>
        </label>
        <label class="search-bar__filter">
          <input type="radio" :checked="searchType === SEARCH_BY.TITLE" @change="onSearchTypeChanged(SEARCH_BY.TITLE)">
          <span>Search by Title</span>
        </label>
        <label class="search-bar__filter">
          <input type="radio" :checked="searchType === SEARCH_BY.BODY" @change="onSearchTypeChanged(SEARCH_BY.BODY)">
          <span>Search by Body</span>
        </label>
        <label class="search-bar__filter">
          <input type="radio" :checked="searchType === SEARCH_BY.ID" @change="onSearchTypeChanged(SEARCH_BY.ID)">
          <span>Search by ID</span>
        </label>
        <label class="search-bar__filter">
          <input type="radio" :checked="searchType === SEARCH_BY.URL" @change="onSearchTypeChanged(SEARCH_BY.URL)">
          <span>Search by URL</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import SEARCH_BY from './SearchBy';

export default {
  name: 'SearchBar',
  props: {
    total: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    searchQuery: '',
    searchType: SEARCH_BY.TITLE,
    SEARCH_BY,
    options: [
      10,
      25,
      50,
      100,
      500,
    ],
    perPage: 25,
  }),
  watch: {
    perPage(val) {
      this.$emit('perPageChanged', val);
    },
  },
  methods: {
    onSearchTypeChanged(type) {
      this.searchType = type;
      this.$emit('searchTypeChanged', type);
    },
    queryChanged(event) {
      this.searchQuery = event.currentTarget.value;
      this.$emit('queryChanged', this.searchQuery);
    },
  },
};
</script>

<style scoped>
.search-bar__filters {
  display: flex;
  flex-direction: column;
}
.search-bar__filter {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// SearchBar.vue?8e5a8252